import { useTranslation } from 'react-i18next';
import './Dashboard.scss';
import { useAuthContext } from 'contexts/AuthContext';
import { PUMP_STATUS_COLOR_CLASS, pumpStatusTranslationKey } from './pumpStatusMeta';

export default function PumpCard({
  name,
  pool,
  lastService,
  statusCode,
  unacknowledged_comments_count,
  usageTimeLimitExceeded = false,
  usageTimeWarning = false,
  formattedActiveTime = null,
}) {
  const { t } = useTranslation();
  const { userRole } = useAuthContext();
  const isKorjaaja = userRole === 3;
  const statusLabel = t(pumpStatusTranslationKey(statusCode));
  const statusColorClass = PUMP_STATUS_COLOR_CLASS[Number(statusCode)] || '';

  const usageOverride = usageTimeLimitExceeded ? 'limit' : usageTimeWarning ? 'warning' : null;
  const statusBadgeClass = [
    'status-badge',
    statusColorClass,
    usageOverride === 'limit' ? 'pump-usage-override--limit' : '',
    usageOverride === 'warning' ? 'pump-usage-override--warning' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const showColoredUsageTime =
    Boolean(formattedActiveTime) && (usageTimeLimitExceeded || usageTimeWarning);
  const usageTimeClass = usageTimeLimitExceeded
    ? 'pump-card-usage-time pump-card-usage-time--limit'
    : 'pump-card-usage-time pump-card-usage-time--warning';

  const usageInfoTitle =
    usageTimeLimitExceeded
      ? t('pump_usage_list_limit_hint')
      : usageTimeWarning
        ? t('pump_usage_list_warning_hint')
        : undefined;

  const renderMetaLine = () => {
    if (formattedActiveTime) {
      if (isKorjaaja) {
        return (
          <span className={showColoredUsageTime ? usageTimeClass : undefined}>{formattedActiveTime}</span>
        );
      }
      return (
        <>
          <span className="pump-details-pool">{pool}</span>
          <span className="pump-details-sep text-muted"> | </span>
          <span className={showColoredUsageTime ? usageTimeClass : undefined}>{formattedActiveTime}</span>
        </>
      );
    }
    return isKorjaaja ? lastService : `${pool} | ${lastService}`;
  };

  return (
    <div className="pump-card d-flex justify-content-between align-items-center p-3 border-bottom">
      <div>
        <div className="pump-name font-weight-bold">
          {name}
        </div>
        <div className="pump-details text-muted small d-flex align-items-center flex-wrap">
          {unacknowledged_comments_count > 0 && (
            <>
              <span className="comment-notification-indicator">
                <span className="red-dot"></span>
                <i className="far fa-comment-alt"></i>
                <span className="comment-count">{unacknowledged_comments_count}</span>
              </span>
              <span className="me-2">|</span>
            </>
          )}
          {renderMetaLine()}
        </div>
      </div>
      <div
        className={statusBadgeClass}
        title={usageOverride ? usageInfoTitle : undefined}
        {...(usageInfoTitle
          ? { 'aria-label': `${usageInfoTitle}. ${statusLabel}` }
          : {})}
      >
        <span className="status-badge-inner">
          {usageOverride && (
            <i className="fas fa-info-circle pump-status-info-icon" aria-hidden />
          )}
          <span>{statusLabel}</span>
        </span>
      </div>
    </div>
  );
} 